/*
 * @Description: 搜索功能
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditTime: 2019-05-30 10:57:11
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Search.css';
import Link from '../Link';
import cx from 'classnames'
import { logout } from '../../controller';

class Search extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      value: '',
      isLoginUser: false,
      isLoginUserName: null
    };
    this.handleChange = this.handleChange.bind(this)
    this.userLogin = this.userLogin.bind(this)
    this.userExits = this.userExits.bind(this)
  }
  componentDidMount() {

    if (window.localStorage.getItem('isLogin') == 'true') {
      // localStorage.setItem('isLogin',false)
      this.setState({
        isLoginUser: true,
        isLoginUserName: window.localStorage.getItem('user') || ''
      })
    }

  }


  shouldComponentUpdate(nextProps, nextState) {
    let ss = true
    // 如果相同就不更新组件
    if (nextProps.seaShow == this.props.seaShow && nextProps.value == this.props.value && this.state.isLoginUser == nextState.isLoginUser) {
      ss = false
    }
    return ss
  }

  componentWillUpdate(nextProps, nextState) {
    if (localStorage.getItem('isLogin') == 'true' && !nextState.isLoginUser || localStorage.getItem('isLogin') == 'false' && nextState.isLoginUser) {
      // console.log('shouldCompoentUpdate  shouldComponentUpdate')

      let hasLogin = localStorage.getItem('isLogin') == 'true' ? true : false

      this.setState({
        isLoginUser: hasLogin,
        isLoginUserName: window.localStorage.getItem('user') || ''
      })
      // ss=true
    }
  }

  handleChange(e) {
    let value = e.target.value;
    this.setState({
      value: value
    })
  }

  userExits = () => {
    this.setState({ isLoginUser: false })
    window.localStorage.setItem('isLogin', 'false')

    logout()
      .then(res => {
        if (!res) return alert('登出失败')

        this.setState({
          isLoginUser: false
        })
      })

    // 11:56  正在修改登录状态  

    this.props.doChangeLoginState(null)
  }

  userLogin = () => {
    const { isLoginUser, isLoginUserName } = this.state
    if (isLoginUser) {
      return (
        <span className={s.user}>
          <Link to="/homepage" className={s.userItem} >{isLoginUserName}</Link>
          <span className={s.userItem} onClick={this.userExits}>退出</span>
        </span>
      )
    } else if (!isLoginUser) {
      return (
        <span className={s.user}>
          <Link to="/login" className={s.login} >登录</Link>
          <Link to="/register" className={s.login}>注册</Link>
        </span>
      )
    }
  }

  render() {
    const { isLoginUser, isLoginUserName } = this.state
    const { fixedLeft } = this.props
    return (
      <div className={cx(s.root, {[s.rootLeft]: fixedLeft})}>

        <div className={cx(s.search, {[s.isHide]: !this.props.seaShow})} style={{ left: fixedLeft ? '0px' : null }}>

          <input
            type="text"
            className={cx(s.input, {[s.seaLeft]: !!fixedLeft})}
            value={this.props.value}
            placeholder="请输入查询品牌"
            onChange={this.props.sea}
            onKeyDown={this.props.keyDown}
            onFocus={this.props.isFocus}
            onBlur={this.props.isFocusFalse}
          />

          <input type="button" className={s.seaBtn}
            style={{ left: fixedLeft ? '0px' : null }}
            onClick={this.props.handleClick}
            onMouseLeave={this.props.onMouseLeave}
            onMouseEnter={this.props.onMouseEnter}></input>

          {/* {this.userLogin()} */}
          {fixedLeft ? null
            : isLoginUser
              ? (<span className={s.user}>
                <span className={s.help}>
                  <b className={s.helpTxt}>
                    <Link to="/help"  >
                      ?
                        </Link>
                  </b>
                </span>
                <Link to="/homepage" className={s.userItem} >{this.state.isLoginUserName || ''}</Link>
                <span className={s.userItem} onClick={this.userExits}>退出</span>
              </span>)
              : (<span className={s.user}>
                <Link to="/login" className={s.login}>登录</Link>
                <Link to="/register" className={s.login}>注册</Link>
              </span>)
          }

        </div>
      </div>
    )
  }

}

export default withStyles(s)(Search);



// WEBPACK FOOTER //
// src/components/Search/Search.js